import { render, staticRenderFns } from "./AppStore.vue?vue&type=template&id=cff215d4&"
import script from "./AppStore.vue?vue&type=script&lang=js&"
export * from "./AppStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports